<template>
	<div class="Offer" :class="{ 'is-mobile': isMobile }">
		<common-body aside="4">
			<div slot="commonMain" class="offer_box">
				<div class="lq-toolbar offer_header">
					<el-input
						v-model="search"
						class="lq-search"
						clearable
						prefix-icon="el-icon-search"
						:placeholder="isMobile ? '搜索' : '搜索单号 / 客户 / 联系人'"
						@keyup.enter.native="searchList" />
					<el-date-picker
						class="lq-date header_date"
						:popper-class="isMobile ? 'lq-date-popper is-mobile-popper' : ''"
						value-format="timestamp"
						:editable="editable"
						:unlink-panels="!isMobile"
						size="small"
						@change="getDate"
						v-model="dateTime"
						type="daterange"
						range-separator="-"
						:start-placeholder="isMobile ? '开始' : '开始日期'"
						:end-placeholder="isMobile ? '结束' : '结束日期'" />
					<el-select
						:class="['lq-filter', 'is-status-' + (filterPlaceStatus || 'none')]"
						popper-class="offer-batch-select-popper"
						size="small"
						clearable
						placeholder="下单状态"
						v-model="filterPlaceStatus"
						@change="searchList">
						<el-option class="offer-batch-opt--1" label="待安排" value="1"></el-option>
						<el-option class="offer-batch-opt--2" label="安排生产" value="2"></el-option>
						<el-option class="offer-batch-opt--shipped" label="已发货" value="shipped"></el-option>
					</el-select>
					<el-select
						:class="['lq-filter', 'is-status-' + (filterPayStatus || 'none')]"
						popper-class="offer-batch-select-popper"
						size="small"
						clearable
						placeholder="付款状态"
						v-model="filterPayStatus"
						@change="searchList">
						<el-option class="offer-batch-opt--1" label="未付款" value="1"></el-option>
						<el-option class="offer-batch-opt--2" label="已付款" value="2"></el-option>
						<el-option class="offer-batch-opt--3" label="售后补单" value="3"></el-option>
					</el-select>
					<div class="lq-toolbar-actions">
						<el-button type="primary" size="small" @click="searchList">查询</el-button>
						<el-button size="small" @click="delSearch">清空</el-button>
						<el-button type="warning" size="small" :disabled="!selectedIds.length" @click="openBatchDialog">
							批量操作{{ selectedIds.length ? '（' + selectedIds.length + '）' : '' }}
						</el-button>
					</div>
				</div>
				<div v-if="categoryName" class="lq-category-hint">当前分类：{{ categoryName }}</div>
				<div class="lq-summary">
					<span class="lq-summary__item">合计合同金额 <b class="lq-summary__money">{{ formatMoney(listSummary.total_amount) }}</b></span>
					<span class="lq-summary__item">未付款金额 <b class="lq-summary__money">{{ formatMoney(listSummary.unpaid_amount) }}</b></span>
					<span class="lq-summary__item">实收差额 <b class="lq-summary__money">{{ formatMoney(listSummary.received_diff) }}</b></span>
				</div>
				<div v-if="isMobile" class="om-sheet">
					<div v-if="!list.length" class="om-empty">暂无报价</div>
					<div v-else class="om-sheet__scroller">
						<table class="om-sheet__table">
							<thead>
								<tr>
									<th class="om-sheet__col-check"></th>
									<th class="om-sheet__col-idx">序号</th>
									<th class="om-sheet__col-no">单号</th>
									<th class="om-sheet__col-name">订货方</th>
									<th class="om-sheet__col-contact">联系人</th>
									<th class="om-sheet__col-phone">联系电话</th>
									<th class="om-sheet__col-amt">合同金额</th>
									<th class="om-sheet__col-amt">实收款</th>
									<th class="om-sheet__col-date">录入日期</th>
									<th class="om-sheet__col-status">下单</th>
									<th class="om-sheet__col-status">付款</th>
									<th class="om-sheet__col-remark">备注</th>
									<th class="om-sheet__col-ops">操作</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(row, idx) in list"
									:key="row.id || idx"
									:class="{ 'is-after-sales': isAfterSalesRow(row), 'is-clickable': !!(ruleList && ruleList.order_see) }"
									@click="openRow(idx)">
									<td class="om-sheet__col-check" @click.stop>
										<el-checkbox :value="isRowSelected(row)" @change="toggleMobileRow(row, $event)" />
									</td>
									<td class="om-sheet__col-idx">{{ idx + 1 }}</td>
									<td class="om-sheet__col-no" :class="{ 'lq-order-no--after-sales': isAfterSalesRow(row) }">
										<span v-if="isAfterSalesRow(row)" class="offer-after-sales-tag">售后</span>
										{{ row.order_number }}
										<div v-if="row.sample_deduct_text" class="sample-deduct-tag">{{ row.sample_deduct_text }}</div>
									</td>
									<td class="om-sheet__col-name">{{ row.customer_id || '-' }}</td>
									<td class="om-sheet__col-contact">{{ row.contacts || '-' }}</td>
									<td class="om-sheet__col-phone">{{ row.contacts_phone || '-' }}</td>
									<td class="om-sheet__col-amt">
										<span class="amount" :class="{ 'amount--after-sales': isAfterSalesRow(row) }">{{ formatMoney(row.total) }}</span>
									</td>
									<td class="om-sheet__col-amt">
										<span class="amount" :class="{ 'amount--after-sales': isAfterSalesRow(row) }">{{ formatReceivedAmount(row) }}</span>
									</td>
									<td class="om-sheet__col-date">{{ row.createTime }}</td>
									<td class="om-sheet__col-status">
										<span v-if="isShippedRow(row)" class="good_pay2">已发货</span>
										<span v-else :class="placeOrderStatusClass(row)">{{ placeOrderStatusText(row) }}</span>
									</td>
									<td class="om-sheet__col-status">
										<span :class="'good_pay' + row.pay_status">{{ row.pay_status_text }}</span>
									</td>
									<td class="om-sheet__col-remark">{{ remarksContent(row) || '无' }}</td>
									<td class="om-sheet__col-ops" @click.stop>
										<div class="om-sheet__ops">
											<el-button v-if="ruleList && ruleList.order_see" type="text" icon="el-icon-view" class="lq-row-action-btn" @click="showDetail(idx)" />
											<el-popconfirm v-if="ruleList && ruleList.order_del" @confirm="delList(idx)"
												confirmButtonType="danger" confirmButtonText="删除" title="确定删除这一单吗？">
												<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" slot="reference" />
											</el-popconfirm>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<el-table v-else ref="listTable" :data="list" stripe class="lq-table lq-table--clickable" style="width: 100%" cell-class-name="good_text"
					header-cell-class-name="good_header" row-key="id" @row-dblclick="handleRowDblClick" @selection-change="onSelectionChange">
					<el-table-column type="selection" width="48" align="center" />
					<el-table-column align="center" width="64" label="序号" class-name="is-num">
						<template slot-scope="scope">
							<div>{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="order_number" label="单号" show-overflow-tooltip>
						<template slot-scope="scope">
							<span
								class="lq-order-no"
								:class="{ 'lq-order-no--after-sales': isAfterSalesRow(scope.row) }">
								{{ scope.row.order_number }}
							</span>
							<div v-if="scope.row.sample_deduct_text" class="sample-deduct-tag">{{ scope.row.sample_deduct_text }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="customer_id" label="订货方" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="72" prop="contacts" label="联系人" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="contacts_phone" label="联系电话" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="112" label="合同金额" class-name="is-amount">
						<template slot-scope="scope">
							<div
								class="amount offer-amount-cell"
								:class="{ 'amount--after-sales': isAfterSalesRow(scope.row) }">
								<span v-if="isAfterSalesRow(scope.row)" class="offer-after-sales-tag">售后</span>
								<span>{{ formatMoney(scope.row.total) }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="96" label="实收款" class-name="is-amount">
						<template slot-scope="scope">
							<div
								class="amount offer-amount-cell"
								:class="{ 'amount--after-sales': isAfterSalesRow(scope.row) }">
								{{ formatReceivedAmount(scope.row) }}
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="createTime" label="录入日期">
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="place_order_status_text" label="下单状态">
						<template slot-scope="scope">
							<el-tooltip
								v-if="isShippedRow(scope.row)"
								content="已发货"
								placement="top"
								:open-delay="300">
								<div class="lq-ship-status-cell">
									<i class="lq-ship-status-icon el-icon-circle-check good_pay2" aria-hidden="true"></i>
								</div>
							</el-tooltip>
							<div v-else :class="placeOrderStatusClass(scope.row)">{{ placeOrderStatusText(scope.row) }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="pay_status_text" label="付款状态">
						<template slot-scope="scope">
							<div :class="'good_pay'+scope.row.pay_status">{{scope.row.pay_status_text}}</div>
						</template>
					</el-table-column>
					<!-- <el-table-column align="center" min-width="8%" prop="purchase_status_text" label="采购状态">
						<template slot-scope="scope">
							<div :class="'good_purchase'+scope.row.purchase_status">{{scope.row.purchase_status_text}}
							</div>
						</template>
					</el-table-column> -->
					<el-table-column align="left" min-width="160" label="备注" class-name="lq-remarks-col">
						<template slot-scope="scope">
							<lq-remarks-cell :text="remarksContent(scope.row)" :empty-text="remarksPlaceholder(scope.row)" />
						</template>
					</el-table-column>
					<el-table-column align="center" width="112" label="操作" fixed="right" class-name="lq-action-col" header-align="center">
						<template slot-scope="scope">
							<div v-if="!ruleList.order_see&&!ruleList.order_del">无</div>
							<div v-else class="lq-row-actions">
								<el-tooltip v-if="ruleList.order_see" content="查看详情" placement="top">
									<el-button type="text" icon="el-icon-view" class="lq-row-action-btn" @click="showDetail(scope.$index)" />
								</el-tooltip>
								<el-popconfirm v-if="ruleList.order_del" @confirm="delList(scope.$index)"
									confirmButtonType="danger" confirmButtonText="删除" title="确定删除这一单吗？">
									<el-tooltip content="删除" placement="top" slot="reference">
										<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" @click.stop />
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-dialog
					:class="['offer-batch-dialog', { 'is-mobile': isMobile }]"
					title="批量操作"
					:visible.sync="batchDialogVisible"
					:width="isMobile ? '96%' : '1100px'"
					append-to-body
					@closed="resetBatchForm">
					<p class="offer-batch-hint">已选 {{ batchRows.length }} 单。上方可一键改全部状态；合并收款按合同金额比例分摊到各单。</p>
					<div class="offer-batch-orders">
						<div v-if="!batchRows.length" class="offer-batch-orders__empty">未找到选中订单</div>
						<template v-else>
							<div class="offer-batch-toolbar">
								<span class="offer-batch-col offer-batch-col--no"></span>
								<span class="offer-batch-col offer-batch-col--cust"></span>
								<span class="offer-batch-col offer-batch-col--total offer-batch-toolbar__sum">合同合计 <b class="offer-batch-money">{{ formatMoney(batchContractSum) }}</b></span>
								<div class="offer-batch-col offer-batch-col--place">
									<el-dropdown trigger="click" @command="applyAllPlace">
										<el-button size="mini" class="offer-batch-action-btn">
											全部生产<i class="el-icon-arrow-down el-icon--right"></i>
										</el-button>
										<el-dropdown-menu slot="dropdown" class="offer-batch-dropdown">
											<el-dropdown-item command="1" class="offer-batch-opt--1">待安排</el-dropdown-item>
											<el-dropdown-item command="2" class="offer-batch-opt--2">生产</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
								<div class="offer-batch-col offer-batch-col--pay">
									<el-dropdown trigger="click" @command="applyAllPay">
										<el-button size="mini" class="offer-batch-action-btn">
											全部付款<i class="el-icon-arrow-down el-icon--right"></i>
										</el-button>
										<el-dropdown-menu slot="dropdown" class="offer-batch-dropdown">
											<el-dropdown-item command="1" class="offer-batch-opt--1">未付</el-dropdown-item>
											<el-dropdown-item command="2" class="offer-batch-opt--2">已付</el-dropdown-item>
											<el-dropdown-item command="3" class="offer-batch-opt--3">售后</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
								<div class="offer-batch-col offer-batch-col--merge">
									<el-input
										class="offer-batch-merge-input offer-batch-money-input"
										size="mini"
										v-model="batchMergeAmount"
										placeholder="实收总额">
										<template slot="prepend">¥</template>
									</el-input>
									<el-button size="mini" class="offer-batch-action-btn" @click="applyMergeReceived">合并收款</el-button>
								</div>
							</div>
							<div class="offer-batch-orders__head">
								<span class="offer-batch-col offer-batch-col--no">单号</span>
								<span class="offer-batch-col offer-batch-col--cust">订货方</span>
								<span class="offer-batch-col offer-batch-col--total">合同金额</span>
								<span class="offer-batch-col offer-batch-col--place">生产状态</span>
								<span class="offer-batch-col offer-batch-col--pay">付款状态</span>
								<span class="offer-batch-col offer-batch-col--amount">收款金额</span>
								<span class="offer-batch-col offer-batch-col--note">收款备注</span>
							</div>
							<div
								v-for="row in batchRows"
								:key="row.id"
								class="offer-batch-order">
								<span class="offer-batch-col offer-batch-col--no" :title="row.order_number || String(row.id)">{{ row.order_number || row.id }}</span>
								<span class="offer-batch-col offer-batch-col--cust" :title="row.customer">{{ row.customer || '-' }}</span>
								<span class="offer-batch-col offer-batch-col--total offer-batch-money">{{ formatMoney(row.total) }}</span>
								<el-select
									:class="['offer-batch-col', 'offer-batch-col--place', 'is-status-' + row.place_order_status]"
									popper-class="offer-batch-select-popper"
									size="mini"
									v-model="row.place_order_status">
									<el-option class="offer-batch-opt--1" label="待安排" value="1"></el-option>
									<el-option class="offer-batch-opt--2" label="生产" value="2"></el-option>
								</el-select>
								<el-select
									:class="['offer-batch-col', 'offer-batch-col--pay', 'is-status-' + row.pay_status]"
									popper-class="offer-batch-select-popper"
									size="mini"
									v-model="row.pay_status">
									<el-option class="offer-batch-opt--1" label="未付" value="1"></el-option>
									<el-option class="offer-batch-opt--2" label="已付" value="2"></el-option>
									<el-option class="offer-batch-opt--3" label="售后" value="3"></el-option>
								</el-select>
								<el-input
									class="offer-batch-col offer-batch-col--amount offer-batch-money-input"
									size="mini"
									v-model="row.received_amount"
									placeholder="金额"
									clearable>
									<template slot="prepend">¥</template>
								</el-input>
								<el-input
									class="offer-batch-col offer-batch-col--note"
									type="textarea"
									:rows="2"
									resize="none"
									v-model="row.received_note"
									placeholder="收款备注"
									maxlength="200"></el-input>
							</div>
						</template>
					</div>
					<div slot="footer">
						<el-button @click="batchDialogVisible = false">取消</el-button>
						<el-button type="primary" :loading="batchSaving" @click="submitBatchStatus">确定</el-button>
					</div>
				</el-dialog>
				<el-pagination class="good_page" :hide-on-single-page="pageSingle" @current-change="changePage"
					:page-size="limit" :pager-count="isMobile ? 5 : 7" prev-text="上一页" next-text="下一页" background layout="prev, pager, next"
					:total="listTotal">
				</el-pagination>
			</div>
		</common-body>
	</div>
</template>

<script>
	import {
		getT
	} from "../assets/js/public.js"
	import {
		fetchQuotationCategory
	} from "../utils/quotation-category.js"
	import { applyMobileViewport } from '@/utils/isMobile'
	export default {
		name: 'Offer',
		data() {
			return {
				isMobile: false,
				categoryId: 0,
				categoryName: '',
				categoryWarned: !1,
				skipNextActivated: !0,
				ruleList: JSON.parse(localStorage.getItem('ruleList')),
				editable: !1,
				search: '',
				page: 1,
				pageSingle: !1,
				limit: 10,
				listTotal: 0,
				list: [],
				listSummary: {
					total_amount: 0,
					unpaid_amount: 0,
					received_diff: 0,
				},
				dateTime: '',
				stime: '',
				etime: '',
				filterPlaceStatus: '',
				filterPayStatus: '',
				selectedIds: [],
				batchDialogVisible: !1,
				batchSaving: !1,
				batchRows: [],
				batchMergeAmount: '',
			}
		},
		computed: {
			batchContractSum() {
				return (this.batchRows || []).reduce((sum, row) => sum + this.contractNumber(row && row.total), 0)
			},
		},
		beforeRouteLeave(to, from, next) {
			from.meta.keepAlive = !1
			next()
		},
		created() {
			this.updateIsMobile()
			this.reload();
		},
		mounted() {
			this.updateIsMobile()
			window.addEventListener('resize', this.updateIsMobile)
			window.addEventListener('orientationchange', this.updateIsMobile)
			if (window.visualViewport) {
				window.visualViewport.addEventListener('resize', this.updateIsMobile)
			}
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateIsMobile)
			window.removeEventListener('orientationchange', this.updateIsMobile)
			if (window.visualViewport) {
				window.visualViewport.removeEventListener('resize', this.updateIsMobile)
			}
		},
		activated() {
			this.updateIsMobile()
			if (this.skipNextActivated) {
				this.skipNextActivated = !1
				return
			}
			this.reload();
		},
		methods: {
			updateIsMobile() {
				this.isMobile = applyMobileViewport()
			},
			remarksContent(row) {
				const text = row && row.remarks != null ? String(row.remarks).trim() : '';
				return text;
			},
			remarksPlaceholder() {
				return '无';
			},
			formatMoney(val) {
				if (val === undefined || val === null || val === '') return '-'
				let text = String(val).trim()
				if (!text) return '-'
				if (text.indexOf('¥') === 0 || text.indexOf('￥') === 0) text = text.slice(1).trim()
				const num = Number(text)
				if (!Number.isFinite(num)) return '¥ ' + text
				return '¥ ' + num.toFixed(2)
			},
			isAfterSalesRow(row) {
				return !!(row && String(row.pay_status) === '3')
			},
			/** 发货单已发货时，下单状态展示「已发货」 */
			isShippedRow(row) {
				return !!(row && String(row.status) === '2')
			},
			placeOrderStatusText(row) {
				const ps = String((row && row.place_order_status) || '1')
				if (ps === '2') return '安排生产'
				return '待安排'
			},
			placeOrderStatusClass(row) {
				return 'good_pay' + String((row && row.place_order_status) || '1')
			},
			/** 实收款：未付款显示「-」；已付款/售后补单展示金额（售后补单可为 0） */
			formatReceivedAmount(row) {
				if (!row) return '-'
				const ps = String(row.pay_status ?? '1')
				if (ps !== '2' && ps !== '3') return '-'
				const n = Number(row.received_amount)
				if (!Number.isFinite(n)) return '-'
				if (ps === '2' && n <= 0) return '-'
				if (ps === '3' && n < 0) return '-'
				return this.formatMoney(n)
			},
			reload() {
				let that = this
				fetchQuotationCategory(that.$fetch.bind(that)).then(function(info) {
					that.categoryId = info.categoryId
					that.categoryName = info.categoryName || ''
					that.page = 1
					that.getList()
				})
			},
			getList(e) {
				let that = this
				if (!that.categoryId) {
					that.list = []
					that.listTotal = 0
					that.listSummary = { total_amount: 0, unpaid_amount: 0, received_diff: 0 }
					that.layoutTable()
					if (!that.categoryWarned) {
						that.categoryWarned = !0
						that.$message({
							message: '请先在产品列表选择产品分类',
							center: !0,
							type: 'warning',
							duration: 1500
						})
					}
					return
				}
				const params = {
					page: that.page,
					limit: that.limit,
					search: that.search,
					type: that.categoryId,
					stime: that.stime,
					etime: that.etime,
				}
				if (that.filterPlaceStatus) params.place_order_status = that.filterPlaceStatus
				if (that.filterPayStatus) params.pay_status = that.filterPayStatus
				that.$fetch('addons/hlm/api.Order/orderList', params).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let list = res.data.list
						list.forEach((item, index) => {
							item.createTime = getT(item.createtime * 1000)
						})
						that.list = list, that.listTotal = res.data.total
						const summary = (res.data && res.data.summary) || {}
						that.listSummary = {
							total_amount: Number(summary.total_amount || 0),
							unpaid_amount: Number(summary.unpaid_amount || 0),
							received_diff: Number(summary.received_diff || 0),
						}
						that.clearSelection()
						that.layoutTable()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			layoutTable() {
				if (this.isMobile) return
				this.$nextTick(() => {
					const table = this.$refs.listTable
					if (table && table.doLayout) table.doLayout()
				})
			},
			getDate(e) {
				if (!e || !e[0] || !e[1]) {
					this.stime = ''
					this.etime = ''
					return
				}
				let that = this
				that.stime = e[0] / 1000, that.etime = e[1] / 1000
				if (e[1] / 1000 < e[0] / 1000) that.stime = e[1] / 1000, that.etime = e[0] / 1000
			},
			changePage(e) {
				let that = this
				that.page = e, that.getList()
			},
			searchList() {
				this.page = 1
				this.getList()
			},
			delSearch() {
				this.search = ''
				this.dateTime = ''
				this.etime = ''
				this.stime = ''
				this.filterPlaceStatus = ''
				this.filterPayStatus = ''
				this.page = 1
				this.getList()
			},
			// 查看详情
			showDetail(e) {
				let that = this,
					id = that.list[e].id
				that.$router.push(`/offerDetail?id=${id}`)
			},
			openRow(index) {
				if (!this.ruleList.order_see) return
				this.showDetail(index)
			},
			handleRowDblClick(row) {
				if (!this.ruleList.order_see) return
				const index = this.list.findIndex((item) => item.id === row.id)
				if (index >= 0) this.showDetail(index)
			},
			onSelectionChange(rows) {
				this.selectedIds = (rows || []).map((row) => row.id).filter(Boolean)
			},
			isRowSelected(row) {
				return !!(row && this.selectedIds.indexOf(row.id) >= 0)
			},
			toggleMobileRow(row, checked) {
				if (!row || !row.id) return
				const next = !!checked
				const idx = this.selectedIds.indexOf(row.id)
				if (next && idx < 0) this.selectedIds.push(row.id)
				if (!next && idx >= 0) this.selectedIds.splice(idx, 1)
			},
			clearSelection() {
				this.selectedIds = []
				this.$nextTick(() => {
					const table = this.$refs.listTable
					if (table && table.clearSelection) table.clearSelection()
				})
			},
			amountToInput(val) {
				if (val === undefined || val === null || val === '') return ''
				const n = Number(String(val).replace(/[¥￥,\s]/g, ''))
				if (!Number.isFinite(n) || n < 0) return ''
				if (n === 0) return ''
				return n.toFixed(2)
			},
			normalizeBatchPayStatus(status) {
				const ps = String(status ?? '1')
				if (ps === '2' || ps === '3') return ps
				return '1'
			},
			normalizeBatchPlaceStatus(status) {
				return String(status ?? '1') === '2' ? '2' : '1'
			},
			buildBatchRows() {
				return (this.selectedIds || []).map((id) => {
					const src = (this.list || []).find((item) => item.id === id)
					if (!src) {
						return {
							id,
							order_number: String(id),
							customer: '',
							total: '',
							place_order_status: '1',
							pay_status: '1',
							received_amount: '',
							received_note: '',
						}
					}
					return {
						id: src.id,
						order_number: src.order_number || '',
						customer: src.customer_id || src.contacts || '',
						total: src.total,
						place_order_status: this.normalizeBatchPlaceStatus(src.place_order_status),
						pay_status: this.normalizeBatchPayStatus(src.pay_status),
						received_amount: this.amountToInput(src.received_amount),
						received_note: src.received_note ? String(src.received_note) : '',
					}
				})
			},
			contractNumber(val) {
				if (val === undefined || val === null || val === '') return 0
				const n = Number(String(val).replace(/[¥￥,\s]/g, ''))
				return Number.isFinite(n) && n > 0 ? n : 0
			},
			applyAllPlace(status) {
				const next = this.normalizeBatchPlaceStatus(status)
				this.batchRows.forEach((row) => {
					row.place_order_status = next
				})
			},
			applyAllPay(status) {
				const next = this.normalizeBatchPayStatus(status)
				this.batchRows.forEach((row) => {
					row.pay_status = next
				})
			},
			applyMergeReceived() {
				const raw = String(this.batchMergeAmount || '').replace(/[¥￥,\s]/g, '').trim()
				const total = Number(raw)
				if (raw === '' || !Number.isFinite(total) || total < 0) {
					this.$message({ message: '请输入合并收款金额', type: 'warning', duration: 1600, center: !0 })
					return
				}
				const rows = this.batchRows || []
				if (!rows.length) return
				const cents = Math.round(total * 100)
				const weights = rows.map((row) => this.contractNumber(row.total))
				const weightSum = weights.reduce((sum, n) => sum + n, 0)
				let used = 0
				rows.forEach((row, index) => {
					let share = 0
					if (index === rows.length - 1) {
						share = Math.max(0, cents - used)
					} else if (weightSum > 0) {
						share = Math.floor(cents * weights[index] / weightSum)
					} else {
						share = Math.floor(cents / rows.length)
					}
					if (index !== rows.length - 1) used += share
					row.received_amount = (share / 100).toFixed(2)
				})
				this.batchMergeAmount = (cents / 100).toFixed(2)
			},
			resetBatchForm() {
				this.batchRows = []
				this.batchMergeAmount = ''
			},
			openBatchDialog() {
				if (!this.selectedIds.length) {
					this.$message({ message: '请先勾选订单', type: 'warning', duration: 1500, center: !0 })
					return
				}
				this.batchRows = this.buildBatchRows()
				const sum = this.batchContractSum
				this.batchMergeAmount = sum > 0 ? sum.toFixed(2) : ''
				this.batchDialogVisible = !0
			},
			submitBatchStatus() {
				const that = this
				if (!that.batchRows.length) return
				const items = that.batchRows.map((row) => ({
					id: row.id,
					place_order_status: that.normalizeBatchPlaceStatus(row.place_order_status),
					pay_status: that.normalizeBatchPayStatus(row.pay_status),
					received_amount: String(row.received_amount || '').trim(),
					received_note: String(row.received_note || '').trim(),
				}))
				that.batchSaving = !0
				const params = {
					ids: that.batchRows.map((row) => row.id).join(','),
					items: JSON.stringify(items),
				}
				that.$fetch('addons/hlm/api.Order/batchUpdataStatus', params).then(function(res) {
					that.batchSaving = !1
					if (res.code == 1) {
						that.batchDialogVisible = !1
						that.$message({
							message: (res && res.msg) || '已更新',
							type: 'success',
							duration: 1500,
							center: !0
						})
						that.getList()
					} else {
						that.$message({
							message: (res && res.msg) || '更新失败',
							type: 'warning',
							duration: 2200,
							center: !0
						})
					}
				}).catch(function(error) {
					console.log(error)
					that.batchSaving = !1
					that.$message({ message: '更新失败', type: 'warning', duration: 1800, center: !0 })
				})
			},
			delList(e) {
				let that = this,
					id = that.list[e].id
				that.$fetch('addons/hlm/api.order/del', {
					id: id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.detailStatus = !1, that.$message({
							message: '删除成功',
							type: 'success',
							duration: 1500,
							center: !0,
							onClose() {

							}
						}), that.getList()
					}
				}).catch(function(error) {
					console.log(error)
				})
			}
		}
	};
</script>

<style src='../assets/css/offer.css'>
	/* px2rem能正常转换 */
</style>
<style src='../assets/css/offer-mobile.css'></style>
